import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import useGetPageIdentity from '@hooks/useGetPageIdentity'
import {
  CONSTRAINTS_FOR_BRAND_LOGOS,
  CONSTRAINTS_FOR_SCHWEIZERILLUSTRIERTE,
} from '@widgets/Author/utils'
import FreeRatioImage from '@components/FreeRatioImage'

import { AuthorAPIProps, BrandLogoProps } from '../types'

const StyledWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing4 },
    },
  }) => css`
    margin-top: ${spacing4};
  `}
`

const BrandLogo: FunctionComponent<
  BrandLogoProps &
    Pick<AuthorAPIProps, 'contentOrigin' | 'contentOriginImageDark'>
> = ({ contentOrigin, contentOriginImageDark, ...logo }) => {
  const { src, alt, height, width, crops } = logo
  const constraints =
    contentOrigin === 'schweizerillustrierte'
      ? CONSTRAINTS_FOR_SCHWEIZERILLUSTRIERTE
      : CONSTRAINTS_FOR_BRAND_LOGOS
  const { isVideoOnly } = useGetPageIdentity()
  return (
    <StyledWrapper>
      <FreeRatioImage
        src={
          isVideoOnly && contentOriginImageDark?.src
            ? contentOriginImageDark.src
            : src
        }
        alt={alt ?? `${contentOrigin}-logo`}
        originalDimensions={
          isVideoOnly && contentOriginImageDark?.src
            ? {
                width: contentOriginImageDark.width,
                height: contentOriginImageDark.height,
              }
            : { width, height }
        }
        constraints={constraints}
        crops={
          isVideoOnly && contentOriginImageDark?.src
            ? (contentOriginImageDark.crops ?? {})
            : (crops ?? {})
        }
        {...(!isVideoOnly && contentOriginImageDark?.src
          ? {
              darkModeImage: {
                src: contentOriginImageDark.src,
                originalDimensions: {
                  width: contentOriginImageDark.width,
                  height: contentOriginImageDark.height,
                },
                crops: contentOriginImageDark.crops ?? {},
              },
            }
          : {})}
      />
    </StyledWrapper>
  )
}

export default BrandLogo
